module.exports = __webpack_public_path__ + "static/media/10.c8c1bc59.jpg";